/** Shared with the site header's on-this-page nav, so the anchors cannot drift. */
export const DOC_SECTIONS = {
  features: { id: 'key-features', title: 'Key Features' },
  gettingStarted: { id: 'getting-started', title: 'Getting Started' },
  connect: { id: 'connect', title: 'Connect' },
  examples: { id: 'try-asking', title: 'Try asking' },
} as const;
